var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTravaux(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100.839,
    height: 52.021,
    viewBox: "0 0 100.839 52.021",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_42",
    "data-name": "Trac\\xE9 42",
    d: "M708.191,651h16.675v11.544H708.191Zm0,0",
    transform: "translate(-708.191 -651)",
    fill: "#006297"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_44",
    "data-name": "Trac\\xE9 44",
    d: "M604.281,591.918h20.545v18.329H604.281Zm0,0",
    transform: "translate(-604.281 -591.918)",
    fill: "#006297"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_47",
    "data-name": "Trac\\xE9 47",
    d: "M833.449,375.8h37.43v30.338h-37.43Zm0,0",
    transform: "translate(-833.449 -375.801)",
    fill: "#006297"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_49",
    "data-name": "Trac\\xE9 49",
    d: "M894.109,625h13.966v14.53H894.109Zm0,0",
    transform: "translate(-894.109 -625)",
    fill: "#006297"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_51",
    "data-name": "Trac\\xE9 51",
    d: "M521,298.543h15.274v16.245H521Zm0,0",
    transform: "translate(-521 -298.543)",
    fill: "#006297"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sans_titre_1920_1200_px_1_",
    "data-name": "Sans titre (1920\\xA0\\xD7\\xA01200\\xA0px) (1)",
    transform: "translate(-281.313 -298.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_39",
    "data-name": "Trac\\xE9 39",
    d: "M295.083,603.913v0a.848.848,0,0,0-.816.878l-.009.387a2.052,2.052,0,0,1-.454,1.346l-7.153,8.868a2.05,2.05,0,0,1-3.19-2.576l6.48-8.035a.852.852,0,0,0,.188-.559l-.013-2.813a.847.847,0,1,0-1.693.053l0,2.5-6.283,7.79a3.748,3.748,0,0,0,2.317,6.052,3.769,3.769,0,0,0,1.747-.135l.106-.036a3.738,3.738,0,0,0,1.655-1.176l7.152-8.868a3.75,3.75,0,0,0,.829-2.461l.009-.4a.845.845,0,0,0-.877-.812",
    transform: "translate(0 -267.352)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_40",
    "data-name": "Trac\\xE9 40",
    d: "M375.887,430.926l-.041-.025-5.285-3.088.534-6.39v-.02c0-.018,0-.035.006-.052a5.645,5.645,0,0,0-.515-2.845,4.927,4.927,0,0,0-2.038-2.2,5.048,5.048,0,0,0-5.711.533.874.874,0,0,0-.1.081l-.02.019-.044.039a.384.384,0,0,0-.045.048l-12.442,12.193a.91.91,0,0,0-.075.084,4.419,4.419,0,0,0-1.079,2.151,4.808,4.808,0,0,0-.04,1.887l.011.074a4.791,4.791,0,0,0,.995,2.233,5.9,5.9,0,0,0,1.691,1.468c.02.013.04.026.061.037l8.813,4.726,3.77,9.86a3.756,3.756,0,0,0,.92,1.379,3.711,3.711,0,0,0,.7.525,3.757,3.757,0,0,0,2.416.465,3.814,3.814,0,0,0,.8-.209,3.751,3.751,0,0,0,2.159-4.837l-4.258-11.137a3.748,3.748,0,0,0-1.683-1.939l-6.049-3.172,3.489-3.244a.857.857,0,0,0-1.166-1.256l-3.9,3.629-.43-.239a.847.847,0,1,0-.819,1.484l8.057,4.28a2.052,2.052,0,0,1,.922,1.061l4.258,11.137a2.054,2.054,0,0,1-1.182,2.649,2.018,2.018,0,0,1-.436.115,2.062,2.062,0,0,1-2.21-1.3l-3.88-10.149a.85.85,0,0,0-.381-.438l-9.03-4.846-.047-.028a4.513,4.513,0,0,1-1.692-1.941,3.114,3.114,0,0,1-.18-1.908,2.754,2.754,0,0,1,.711-1.408l.01-.012,12.508-12.259a.906.906,0,0,0,.065-.071,3.336,3.336,0,0,1,3.714-.29,3.542,3.542,0,0,1,1.694,3.435s0,.008,0,.013,0,.031-.005.046l-.578,6.923a.853.853,0,0,0,.417.8l5.747,3.358.02.012a1.467,1.467,0,0,1-1.478,2.535l-.021-.012-7.008-4.1-.018-.011a1.46,1.46,0,0,1-.7-1.378l.614-7.264a.847.847,0,1,0-1.688-.143l-.613,7.265a3.163,3.163,0,0,0,1.514,2.969l.042.025,7.007,4.095.046.026a3.162,3.162,0,0,0,3.183-5.464",
    transform: "translate(-59.845 -103.67)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6",
    "data-name": "Groupe 6",
    transform: "translate(330.337 339.02)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_41",
    "data-name": "Trac\\xE9 41",
    d: "M723.154,660.239a1.368,1.368,0,0,1-1.264.8H711.429a1.4,1.4,0,0,1-1.076-2.293l4.022-4.8a2.986,2.986,0,0,1,2.3-1.048h.008A3.108,3.108,0,0,1,719,653.916a.88.88,0,0,0,.069.1l3.9,4.74A1.369,1.369,0,0,1,723.154,660.239Zm-2.693-7.193a.788.788,0,0,0-.082-.117,4.787,4.787,0,0,0-3.689-1.717h-.011a4.671,4.671,0,0,0-3.6,1.652l-4.024,4.8,0,0h0a3.089,3.089,0,0,0,2.374,5.063H721.89a3.089,3.089,0,0,0,2.383-5.052l-3.811-4.633",
    transform: "translate(-708.321 -651.187)",
    fill: "#006297"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7",
    "data-name": "Groupe 7",
    transform: "translate(318.403 332.235)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_43",
    "data-name": "Trac\\xE9 43",
    d: "M614.439,608.56h-5.806a1.4,1.4,0,0,1-1.076-2.294l9.465-11.4a2.988,2.988,0,0,1,2.306-1.082h.007a2.988,2.988,0,0,1,2.307,1.093l1.827,2.221a.844.844,0,0,0,1.3-1.074l-1.827-2.221a4.67,4.67,0,0,0-3.607-1.709h-.011a4.67,4.67,0,0,0-3.6,1.692l-2.352,2.831-7.646-4.582a.845.845,0,0,0-.867,1.45l7.421,4.447-6.021,7.25a3.089,3.089,0,0,0,2.374,5.063h5.806a.845.845,0,0,0,0-1.689",
    transform: "translate(-604.43 -591.92)",
    fill: "#006297"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_45",
    "data-name": "Trac\\xE9 45",
    d: "M329.483,397.8a3.158,3.158,0,0,0,4.4-.589l.029-.038,3.678-4.9,1.6.473a.845.845,0,1,0,.343-1.651l-2.127-.589a.851.851,0,0,0-.845.322l-4,5.323-.014.018a1.467,1.467,0,0,1-2.346-1.763l.015-.02,4.877-6.491.013-.017a1.458,1.458,0,0,1,1.449-.539l6.08,1.544a.847.847,0,0,0,.337-1.661l-6.08-1.543a3.16,3.16,0,0,0-3.123,1.16l-.03.039-4.876,6.49-.031.043a3.168,3.168,0,0,0,.659,4.386",
    transform: "translate(-41.523 -77.073)",
    fill: "#006297"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8",
    "data-name": "Groupe 8",
    transform: "translate(344.722 307.415)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_46",
    "data-name": "Trac\\xE9 46",
    d: "M864.323,387.907h-2.069l4.779-10.276h2.179v10.276Zm-3.932,0h-9.67l4.78-10.276h9.67Zm-11.531,0h-9.671l4.78-10.276h9.67Zm-11.532,0h-2.166V377.631h6.947Zm32.729,1.689a.844.844,0,0,0,.844-.845V376.786a.845.845,0,0,0-.844-.845h-35.74a.845.845,0,0,0-.844.845v11.965a.844.844,0,0,0,.844.845h4.891l.009,14.951h-4.9a.844.844,0,0,0,0,1.689H841.3a.844.844,0,0,0,0-1.689H840.9l-.009-14.951h22.584v14.951h-9.942a.844.844,0,0,0,0,1.689h16.52a.844.844,0,0,0,0-1.689h-4.89V389.6h4.89",
    transform: "translate(-833.47 -375.925)",
    fill: "#006297"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_9",
    "data-name": "Groupe 9",
    transform: "translate(351.688 336.034)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_48",
    "data-name": "Trac\\xE9 48",
    d: "M897.675,637.858l1.04-3.264,5.118,0,1.038,3.259Zm2.02-6.343h3.156l.444,1.394-4.042,0Zm1.517-4.761a.063.063,0,0,1,.061-.045.064.064,0,0,1,.061.045l.978,3.072h-2.079Zm6.172,11.1h-.742l-2.367-7.433-.006-.017-1.327-4.168a1.752,1.752,0,0,0-3.339,0l-1.327,4.168-.006.017-.974,3.06-.006.018-1.387,4.354h-.747a.845.845,0,0,0,0,1.689h12.228a.845.845,0,0,0,0-1.689",
    transform: "translate(-894.289 -625.017)",
    fill: "#006297"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_10",
    "data-name": "Groupe 10",
    transform: "translate(308.839 298.543)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_50",
    "data-name": "Trac\\xE9 50",
    d: "M523.907,306.078l8.08,3.893a4.557,4.557,0,1,1-8.08-3.893Zm3.3-5.2a5.011,5.011,0,0,1,6.686,3.221,7.452,7.452,0,0,1-.505,4.67l-9.024-4.347-.043-.045a.839.839,0,0,0-.428-.224A7.412,7.412,0,0,1,527.206,300.879Zm-5.445,4.164.594.286h0l.011.006a6.246,6.246,0,0,0,9.2,8.241,6.281,6.281,0,0,0,1.959-2.865l1.719.829a.845.845,0,0,0,.732-1.522l-1.067-.514a9.163,9.163,0,0,0,.611-5.842,6.293,6.293,0,0,0-1.306-2.488,7.009,7.009,0,0,0-4.925-2.373,6.292,6.292,0,0,0-2.758.53,9.163,9.163,0,0,0-4.19,4.135.845.845,0,0,0-.581,1.578",
    transform: "translate(-521.25 -298.767)",
    fill: "#006297"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_52",
    "data-name": "Trac\\xE9 52",
    d: "M566.938,324.026a4.051,4.051,0,0,1,4.382,2.153.844.844,0,1,0,1.436-.888,6.569,6.569,0,0,0-2.632-2.485,5.448,5.448,0,0,0-3.519-.436.845.845,0,0,0,.334,1.656",
    transform: "translate(-251.928 -20.988)",
    fill: "#006297"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravaux);
export default __webpack_public_path__ + "static/media/travaux.1d94ad97d4f158486e280292feb2a409.svg";
export { ForwardRef as ReactComponent };